<template>
  <div class="messages">
    <h1 class="subheading grey--text">Site Messages</h1>

    <v-container class="my-5">
      <v-card class="pa-2 ma-2" outlined tile>
        <v-card-title>
          <h2>Site Message</h2>
        </v-card-title>
        <v-card-text>
          <v-form class="px-3" ref="form">
            <v-textarea
              v-model="sitemessage"
              label="Site Message"
              prepend-icon="edit"
              :rules="inputRules"
            ></v-textarea>

            <v-spacer></v-spacer>

            <v-btn
              @click="submitSiteMessage"
              class="success mx-0 mt-3"
              :loading="loading"
              ><v-icon>done</v-icon><span>Set Site Message</span></v-btn
            >
          </v-form>
        </v-card-text>
      </v-card>
      <v-spacer></v-spacer>
      <v-card class="pa-2 ma-2" outlined tile>
        <v-card-title>
          <h2>Set Order Page Message</h2>
        </v-card-title>
        <v-card-text>
          <v-form class="px-3" ref="form">
            <v-textarea
              v-model="orderpagemessage"
              label="Order Page Message"
              prepend-icon="edit"
              :rules="inputRules"
            ></v-textarea>

            <v-spacer></v-spacer>

            <v-btn
              @click="submitOrderPageMessage"
              class="success mx-0 mt-3"
              :loading="loading"
              ><v-icon>done</v-icon><span>Set Order Page Message</span></v-btn
            >
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  data() {
    return {
      sitemessage: "",
      orderpagemessage: "",
      inputRules: [
        v => !!v || "This field is required",
        v => v.length >= 3 || "Minimum length is 3 characters"
      ],
      loading: false
    };
  },
  created() {
    this.getCurrentMessages();
  },
  methods: {
    async getCurrentMessages() {
      let mess1 = await cartApi.getMessage("site");
      this.sitemessage = mess1.message[0].message;
      let mess2 = await cartApi.getMessage("orderpage");
      this.orderpagemessage = mess2.message[0].message;
    },
    async submitSiteMessage() {
      this.loading = true;
      await cartApi.postMessage("site", this.sitemessage);
      this.loading = false;
    },
    async submitOrderPageMessage() {
      this.loading = true;
      await cartApi.postMessage("orderpage", this.orderpagemessage);
      this.loading = false;
    }
  }
};
</script>

<style></style>
